import { type IconName } from "../SvgProvider.js";
import { CardTitle as BaseCardTitle } from "../vendor/Card/CardTitle.js";

export type CardTitleProps = {
  /**
   * A React component or the name of an HTML tag used to render the element.
   *
   * @default h1
   */
  as?: React.ElementType | undefined;

  /**
   * Content to render within the element.
   */
  children?: React.ReactNode | undefined;

  /**
   * A class property to attach to the element.
   *
   * @see {@link !Element.className}
   */
  className?: string | undefined;

  /**
   * If `true`, the component is disabled.
   *
   * @default false
   */
  disabled?: boolean;

  /**
   * The name of an icon to render at the beginning of the title content.
   */
  iconName?: IconName | undefined;

  /**
   * An identifier to attach to the element.
   *
   * @see {@link !Element.id}
   */
  id?: string | undefined;

  /**
   * Whether to render the content as an inline element.
   *
   * @default false
   */
  inline?: boolean | undefined;
};

/**
 * A title element that can be rendered within a Card.
 *
 * ![Card title](./screenshots/card.png)
 *
 * @param props
 * @see {@link CardTitle}
 * @see {@link CardFooter}
 */
export const CardTitle = (props: CardTitleProps) => (
  <BaseCardTitle {...props} />
);
